import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Splash from "@/pages/splash/page";
import Home from "@/pages/home/page";
import Divination from "@/pages/divination/page";
import Interpretation from "@/pages/interpretation/page";
import Profile from "@/pages/profile/page";
import AppLayout from "@/components/feature/AppLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Splash />,
  },
  {
    element: <AppLayout />,
    children: [
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/divination",
        element: <Divination />,
      },
      {
        path: "/interpretation",
        element: <Interpretation />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;